import { render } from "./realColourMap.vue?vue&type=template&id=3a5fadbf"
import script from "./realColourMap.vue?vue&type=script&lang=js"
export * from "./realColourMap.vue?vue&type=script&lang=js"

import "./realColourMap.vue?vue&type=style&index=0&id=3a5fadbf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__